var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.062,
    height: 15.49,
    viewBox: "0 0 18.062 15.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.085,38.319a1.291,1.291,0,0,1,.224-.017H14.051l-.278-.129a2.585,2.585,0,0,1-.73-.517L9.47,34.083a1.338,1.338,0,0,1-.187-1.712,1.292,1.292,0,0,1,1.938-.168l6.462,6.461a1.292,1.292,0,0,1,0,1.828h0l-6.462,6.461a1.292,1.292,0,0,1-1.938-.129,1.338,1.338,0,0,1,.187-1.712l3.567-3.58a2.585,2.585,0,0,1,.646-.472l.388-.174H1.38A1.338,1.338,0,0,1,.017,39.8,1.292,1.292,0,0,1,1.085,38.319Z",
    transform: "translate(0 -31.842)",
    fill: "#176eb5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c5865e5a40c95c1a75e36428e711979b.svg";
export { ForwardRef as ReactComponent };